import { Box, Typography, styled } from '@mui/material';
import { addElipsis } from '../../../utils/common-utils';

const Container = styled(Box)`
  border: 1px solid #e0e0e0;
  border-radius: 10px;
  margin: 10px;
  height: 350px;
  display: flex;
  align-items: center;
  flex-direction: column;
  transition: transform 0.3s ease;
  background-color: #f5f8fa;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);

  &:hover {
    transform: translateY(-5px);
    box-shadow: 0 8px 16px rgba(0, 0, 0, 0.3);
    background-color: #fcfafa;
  }
`;

const Image = styled('img')`
  width: 100%;
  border-radius: 10px 10px 0 0;
  object-fit: cover;
  height: 150px;
`;

const Text = styled(Typography)`
  color: #555555;
  font-size: 14px;
  font-weight: 500;
  margin-bottom: 8px;
`;

const Heading = styled(Typography)`
  font-size: 18px;
  font-weight: 600;
  margin-top: 10px;
  text-align: center;
  color: #3f51b5;
`;

const Details = styled(Typography)`
  font-size: 14px;
  word-break: break-word;
  margin: 10px;
  color: #777777;
`;

const Post = ({ post }) => {
  const url = post.picture
    ? post.picture
    : 'https://images.unsplash.com/photo-1498050108023-c5249f4df085?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=752&q=80';
  return (
    <Container>
      <Image src={url} alt="blog" />
      <Text>{post.categories}</Text>
      <Heading>{addElipsis(post.title, 20)}</Heading>
      <Text>Posted By: {post.username}</Text>
      <Details>{addElipsis(post.description, 100)}</Details>
    </Container>
  );
};

export default Post;
